import { render, staticRenderFns } from "./LoanCollateralAssetProductFieldsDisplay.vue?vue&type=template&id=9ea11e98&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetProductFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetProductFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetProductFieldsDisplay.vue?vue&type=style&index=0&id=9ea11e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea11e98",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetProductFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports